import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * get historical data for currencies for a given date or next date available
 * @param {object} _this: context variables
 * @param {string} fieldName: field name to update
 * @param {string} fieldShowLoadingName: field name that defines if the field must be shown loading
 * @param {date} date: date
 * @param {string} currencyPK: currency's primary key
 */
export function getCurrencySettle(
  _this,
  fieldName,
  fieldShowLoadingName,
  date,
  currencyPK,
  fieldDate
) {
  _this.loading[fieldShowLoadingName] = true;
  let params = {
    method: "GET",
    endpoint: "currency_settle",
    query_params: {
      format: "json",
      date: formatDate_YMD(date),
      currency: currencyPK
    }
  };
  return apiService
    .getAll(params)
    .then(data => {
      _this.valuation[fieldName] = data[0].settle;
      _this.valuation[fieldDate] = formatDate_YMD(
        new Date(`${data[0].observation_date}T00:00:00`)
      );
      _this.loading[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this.valuation[fieldName] = "";
      _this.loading[fieldShowLoadingName] = false;
      console.error(error);
    });
}
